import React from 'react';
import { TutorialPage } from '../TutorialPage';

export interface WelcomePageProps {
  currentPage: number;
  totalPages: number;
  onNext: () => void;
  onPrevious: () => void;
  onSkip: () => void;
  onFinish: () => void;
}

/**
 * Tutorial Page 1: Welcome to Wallstreetle
 */
export const WelcomePage: React.FC<WelcomePageProps> = (props) => {
  return (
    <>
      {/* Dimmed backdrop */}
      <div className="fixed inset-0 bg-black/50 z-[9998]" aria-hidden="true" />

      <TutorialPage
        title="Welcome to Wallstreetle!"
        position="center"
        {...props}
      >
      <div className="space-y-4">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src="/assets/site-logo/mini-dark-logo.svg"
            alt="Wallstreetle Logo"
            className="w-24 h-24"
          />
        </div>

        {/* Introduction Text */}
        <div className="text-center space-y-3">
          <p className="text-lg leading-relaxed text-foreground">
            Wallstreetle is my version of Stock Wordle: Guess the ticker with analysis used on Wall Street
          </p>
        </div>

        {/* Feature List */}
        <ul className="space-y-3 mt-6 ml-6">
          <li className="flex items-start gap-3">
            <span className="text-blue-600 dark:text-blue-400 text-xl flex-shrink-0">•</span>
            <span className="text-foreground">
              <strong>What it is:</strong> Wallstreetle is a daily stock guessing game that doubles as a lightweight stock screener using real fundamentals.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-blue-600 dark:text-blue-400 text-xl flex-shrink-0">•</span>
            <span className="text-foreground">
              <strong>Why it exists:</strong> I built it because I was already screening stocks every day and wanted a faster, more fun way to do it - and something I could confidently give to friends who were just starting to invest.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-blue-600 dark:text-blue-400 text-xl flex-shrink-0">•</span>
            <span className="text-foreground">
              <strong>Why it's different:</strong> The goal isn't to win by being smart - it's to learn one new thing about the market each day, whether you're a beginner or an experienced pro.
            </span>
          </li>
        </ul>

        {/* Call to Action */}
        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground italic">
            Let's take a quick tour to show you how it works!
          </p>
        </div>

        {/* Attribution */}
        <div className="mt-4 text-center">
          <p className="text-sm text-muted-foreground">
            Solo-developed by Toj
          </p>
        </div>
      </div>
    </TutorialPage>
    </>
  );
};

export default WelcomePage;
